/**
 * Para onde o app aponta em tempo de execução.
 *
 * O padrão é o backend de verdade (`isugar-dev`). Os emuladores só entram com
 * **duas** condições ao mesmo tempo:
 *
 *  1. `VITE_USE_FIREBASE_EMULATORS=true` — bandeira explícita, que vive em
 *     `.env.e2e` e é carregada só com `vite --mode e2e`;
 *  2. `import.meta.env.DEV` — verdadeiro apenas no servidor de desenvolvimento.
 *
 * A segunda condição é o cinto de segurança: um build de produção tem
 * `DEV === false`, então nem um `.env` errado no CI aponta o app publicado
 * para `127.0.0.1`. E o inverso também vale, que é o ponto dos testes E2E:
 * sem a bandeira, nada nesta configuração muda o comportamento de hoje.
 */

const bandeiraEmuladores =
  import.meta.env.VITE_USE_FIREBASE_EMULATORS === "true";

export const USANDO_EMULADORES = bandeiraEmuladores && import.meta.env.DEV;

/** Host dos emuladores. `127.0.0.1` e não `localhost`: no Windows o segundo
 *  resolve para `::1` primeiro e o emulador só escuta em IPv4. */
const EMU_HOST = "127.0.0.1";

export const EMULADORES = {
  // O SDK de Auth quer a URL inteira; os outros querem host e porta separados.
  authUrl: `http://${EMU_HOST}:9099`,
  firestore: { host: EMU_HOST, port: 8080 },
  database: { host: EMU_HOST, port: 9000 },
  storage: { host: EMU_HOST, port: 9199 },
};

const API_PRODUCAO = "https://us-central1-isugar-dev.cloudfunctions.net/api";
const API_EMULADOR = `http://${EMU_HOST}:5001/isugar-dev/us-central1/api`;

/** Base da API HTTP (Cloud Functions). `VITE_API_BASE_URL` sobrepõe tudo. */
export const API_BASE_URL =
  import.meta.env.VITE_API_BASE_URL ||
  (USANDO_EMULADORES ? API_EMULADOR : API_PRODUCAO);

/** URL do Realtime Database. Com emulador, o SDK resolve pela porta local. */
export const DATABASE_URL = "https://isugar-dev-default-rtdb.firebaseio.com";
